var React = require('react');

function SmokeIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 9C19.667 10.06 20 11.394 20 13C20 16 16.5 17 15 22C14.333 21.425 14 20.592 14 19.5C14 16.018 19 14.21 19 9ZM14.5 5C15.1641 6.22816 15.508 7.60383 15.5 9C15.5 14 9.5 15 11.5 22C9.833 20.84 9 19.173 9 17C9 13.675 14.5 11 14.5 5ZM10 1C10.667 2.333 11 3.833 11 5.5C11 11.5 2 13 8 22C5.5 21.5 3.5 19 3.5 16C3.5 9.5 10 8.5 10 1Z","fill":"url(#paint0_linear_420_16315)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_420_16315","x1":"7.72807","y1":"3.62513","x2":"18.791","y2":"17.3322","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.3125","stopColor":"#5D44B7","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#FFA6C1","key":1})]))]);
}

SmokeIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SmokeIcon;

SmokeIcon.default = SmokeIcon;
